import ProtectedRoute from '../ProtectedRoute';
import Subscribe from './Subscribe';

const SubscribeRoute = () => (
  <ProtectedRoute
    key="subscribe"
    exact
    path="/subscribe"
    page={<Subscribe />}
  />
);

export default SubscribeRoute;
